<template>
    <div class="inner-main">
        <div class="header">
            <span class="iconfont iconarrowleft-outline back-info" @click="goBack"></span>
        </div>
        <div class="main">
            <div class="fundding-news">
                <div class="top-info">
                    <div class="news-title">
                        {{$t("fundingNews")}}
                    </div>
                    <div id="funding-news-filter" class="filter">
                        <div class="right" @click="showSearch">筛选
                            <i class="iconfont iconfilter-outline"></i>
                        </div>
                        <van-popup v-model="showSearchPanel" position="right" :style="{ height: '100%', width: '80%' }">
                            <search-panel :type="searchPanelType" @search="searchByPanel"></search-panel>
                        </van-popup>

                    </div>
                    <!-- <div class="time" @click="changeTimeOrder">
                        <div>
                            <span>按时间排序</span>
                            <i class="iconfont icondown-chevron-outline " style=" display: inline-block;" :class="{'anim':isUp ,'anim-reset':!isUp}"></i>
                        </div>
                    </div> -->
                </div>

                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">

                    <div class="item" v-for="item in dataList" :key="item.id" @click="goNewsDetail(item.id)">
                        <div class="top">
                            <div class="name">
                                {{item.newsTitle}}
                            </div>
                            <div class="date">
                                {{getDate(item.publishDate)}}
                            </div>
                        </div>
                        <div class="news-info">
                            {{ getSubContent(item)}}
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
import webService from "@network/webService";
import common from "@common/common";
import SearchPanel from "@components/common/SearchPanel";

export default {
    data() {
        return {
            loading: false,
            finished: false,
            dataList: [],
            currentPage: 0,
            isUp: false,
            isDesc: true,
            oldSearchModel: {},
            showSearchPanel: false,
            searchPanelType: common.searchTypeEnum.onlyDates,
        };
    },

    components: {
        SearchPanel,
    },

    computed: {},

    mounted() {
        // this.init();
    },

    methods: {
        changeTimeOrder() {
            this.isDesc = !this.isDesc;
            this.isUp = !this.isUp;
            this.currentPage = 0;
            this.dataList = [];
            this.onLoad();
        },

        showSearch() {
            this.showSearchPanel = true;
        },
        searchByPanel(searchParams) {
             if(searchParams.hasFilter) {
                document.getElementById('funding-news-filter').classList.add('has-filter');
            } else {
                document.getElementById('funding-news-filter').classList.remove('has-filter');
            }
            this.currentPage = 0;
            this.dataList = [];
            //   debugger;
            if (this.searchPanelType == common.searchTypeEnum.onlyDates) {
                this.oldSearchModel.InvestmentDate =
                    searchParams.InvestmentDate;
            }
            this.showSearchPanel = false;
            this.onLoad();
        },
        onLoad() {
            var id = this.$route.query.id;
            var param = {
                PageSize: 20,
                Page: this.currentPage,
                InvestmentDate: this.oldSearchModel.InvestmentDate,
                OrderType: this.isDesc ? 2 : 1,
            };
            webService.getNewsFundingList(id, param).then((res) => {
                console.log(res);
                for (let i = 0; i < res.data.length; i++) {
                    this.dataList.push(res.data[i]);
                }
                this.loading = false;
                // debugger;
                if (res.data.length <= 0) {
                    this.finished = true;
                }
                this.currentPage++;
            });
        },
        goBack() {
            this.$router.go(-1);
        },
        getSubContent(item) {
            var cont  = item.newsContent;
            if(item.isAdd){
                if(cont && cont.length>90){
                    return cont.substr(0,90)+'...';
                }
                return cont;
            }
            let contentsArr = JSON.parse(cont);
            for (let i = 0; i < contentsArr.length; i++) {
                let obj = contentsArr[i];
                if (common.isEmpty(obj.image) && !common.isEmpty(obj.content)) {
                    return obj.content;
                }
            }
        },
        getDate(date) {
            if (!common.isEmpty(date)) {
                return this.$moment(date).format("yyyy/MM/DD");
            } else {
                return "None";
            }
        },
        goNewsDetail(id) {
            this.$router.push({
                path: "/newsDetail",
                query: {
                    id: id,
                    type: 0,
                },
            });
        },
    },
};
</script>
<style lang='less' scoped>
.inner-main {
    height: 100%;
}

.main {
    height: calc(100% - 63px);
}
.fundding-news {
    height: calc(100% - 63px);
}
/deep/ .van-list {
    height: calc(100% - 63px);
    overflow: auto;
    padding-top: 30px;
    
    padding: 1.125rem;
}

.header {
    padding: 1rem;
    padding-bottom: 10px;
}
.back-info {
    font-size: 34px;
    color: #7d7d7d;
}
.fundding-news {
    // padding: 1.125rem;
    // padding-top: 0;

    .top-info {
        // padding-bottom: 18px;
        .time {
            flex: 1;
            text-align: right;
            font-size: 14px;
            color: #464646;
        }
    }

    .news-title {
        padding: 0.25rem 1.125rem 1rem 1.125rem;
        margin-bottom: 30px;
        margin-bottom: 10px;
        font-size: 26px;
        color: #2d2d2d;
        font-weight: 550;
    }

    .filter {
        display: flex;
        border-bottom: 1px solid #dedede;
        margin-bottom: 8px;
        color: #7d7d7d;
        padding: 0 1.125rem 0.5rem 1.125rem;
        .left {
            flex: 1;
        }
        .center {
            flex: 1;
            text-align: center;
        }
        .right {
            flex: 1;
            text-align: right;
        }
    }
    .top {
        display: flex;
        .name {
            font-size: 14px;
            color: #464646;
            font-weight: bold;
            margin-bottom: 12px;
            flex: 1;
        }
        .date {
            font-size: 12px;
            color: #7d7d7d;
            padding-top: 2px;
            width: 24%;
            text-align: right;
        }
    }
    .news-info {
        font-size: 14px;
        color: #7d7d7d;
        line-height: 22px;
        margin-bottom: 18px;

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/content/org/ListFundingNews.vue